import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './Style.css';
import ModalTrigger from '../../../shared/modal/ModalTrigger';
import { convertTextValues } from '../../../shared/util/assessments';

type OneToFiveSliderProps = {
  questionid: string;
  questionTitle: string;
  modalText?: string;
  onOpenModal?: (html?: unknown) => void;
  onSetValue: (value: { id: string; value: string }) => void;
  assessmentValues: Record<string, unknown>;
  textValues: string[];
  width: string;
  labelId?: string;
};

export function OneToFiveSlider({
  questionid,
  questionTitle,
  modalText,
  onOpenModal,
  onSetValue,
  assessmentValues,
  textValues,
  width,
  labelId,
}: OneToFiveSliderProps) {
  const [textValue, setTextValue] = useState('');
  const [rangeValue, setRangeValue] = useState('3');
  const { t } = useTranslation();

  useEffect(() => {
    if (assessmentValues[questionid]) {
      const text = convertTextValues(assessmentValues[questionid].toString(), textValues);
      setTextValue(text);
      setRangeValue(assessmentValues[questionid].toString());
    } else {
      setTextValue(textValues[2]);
      onSetValue({ id: questionid, value: '3' });
    }
  }, []);

  const handleRangeChange = (event) => {
    const { value } = event.target;
    setRangeValue(value);
    setTextValue(convertTextValues(value, textValues));
    onSetValue({ id: questionid, value });
  };

  return (
    <div className={`req question_block${width}`}>
      <fieldset
        id={questionid}
        data-input-type="one-to-five-slider"
        aria-labelledby={`${labelId} ${questionid ? `${questionid}-legend` : ''}`}
      >
        <legend className="assessment_question_title" id={`${questionid}-legend`}>
          {questionTitle}
        </legend>
        {modalText && (
          <ModalTrigger
            modalText={modalText}
            onOpenModal={onOpenModal}
            question={questionid}
            questionTitle={questionTitle}
          />
        )}
        <div className="answer_block fs-exclude">
          <div className="painSlider pain_slider" id={`${questionid}-five-pain-slider-container`}>
            <div className="leftLabel">{`${textValues[0]} (1)`}</div>
            <div className="rightLabel">{`${textValues[4]} (5)`}</div>
            <div className={`range-container value-${rangeValue}`}>
              <input
                type="range"
                min="1"
                max="5"
                value={rangeValue}
                onChange={handleRangeChange}
                id={`${questionid}_slider`}
                aria-valuetext={textValue}
                aria-label={`${questionTitle} ${t('slider.description.from')} ${textValues[0]} (1) ${t('slider.description.to')} ${textValues[4]} (5)`}
                data-uw-ignore-s3
              />
            </div>
            <label
              className="valueHandle"
              id={`${questionid}_value_handle`}
              htmlFor={`${questionid}_slider`}
            >
              {textValue}
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  );
}
